import { fade } from '@material-ui/core/styles'

const modernBlueTheme = {
  name: 'MODERN_BLUE',
  typography: {
    body2: {
      fontSize: 14
    },
    button: {
      fontSize: 14
    },
    fontFamily:
      'Roboto,Tahoma,Helvetica,Arial,sans-serif,-apple-system,BlinkMacSystemFont,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
  },
  overrides: {
    MuiButton: {
      root: {
        '&.ng-button-outlined, &.ng-button-filled-secondary': {
          color: '#236EC3 !important',
          boxShadow: 'inset 0 0 0 2px #236EC3 !important',
          '&:hover': {
            backgroundColor: `${fade('#236EC3', 0.15)} !important`,
            boxShadow: 'inset 0 0 0 2px #236EC3 !important'
          },
          '&:focus': {
            backgroundColor: `${fade('#236EC3', 0.3)} !important`
          }
        },
      }
    },
    MuiDrawer: {
      paperAnchorDockedLeft: {
        borderRight: 0
      }
    },
    MuiIconButton: {
      root: {
        '&.MuiButtonBase-root.ng-button-func.outlined': {
          boxShadow: `0 0 1px 0 ${fade('#236EC3', 0.32)}, 0 2px 2px -2px ${fade('#236EC3', 0.25)} !important`
        },
        '&:not(.MuiSwitch-switchBase):hover': {
          backgroundColor: '#E9F1F9'
        }
      }
    },
    MuiChip: {
      root: {
        backgroundColor: '#F2F1EF',
        color: '#121212'
      }
    },
    MuiLink: {
      root: {
        color: '#000000 !important'
      }
    },
    MuiTableCell: {
      head: {
        '& .ng-form-control.no-label': {
          '& > input[type="text"].MuiFilledInput-input': {
            padding: '8px 4px !important',
            fontSize: '.9rem'
          },
          '& > .MuiInputAdornment-root': {
            '&.MuiInputAdornment-positionEnd': { marginLeft: '0' },
            '& > .MuiIconButton-root': {
              padding: '8px',
              '& svg': {
                width: '.8em',
                height: '.8em'
              }
            }
          }
        },
        '.MuiTableRow-head:not(.table-filter-row) > &': {
          padding: '10px 16px !important'
        },
        '.table-filter-row &': {
          padding: '9.6px',
          '& .MuiGrid-container': {
            flexWrap: 'nowrap'
          }
        }
      }
    }
  },
  palette: {
    type: 'light',
    action: {
      active: 'rgba(0, 0, 0, 0.54)',
      hover: 'rgba(0, 0, 0, 0.04)',
      selected: '#E7F2F2',
      disabled: 'rgba(0, 0, 0, 0.26)',
      disabledBackground: 'rgba(0, 0, 0, 0.12)',
      focus: 'rgba(0, 0, 0, 0.12)'
    },
    primary: {
      50: '#F4F8FC',
      100: '#D3E2F3',
      200: '#A7C5E7',
      300: '#7BA8DB',
      400: '#4F8BCF',
      500: '#397DC9',
      600: '#1C589C',
      700: '#154275',
      800: '#0E2C4E',
      900: '#0B213B',
      main: '#236EC3',
      light: '#659AD5',
      dark: '#154275',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#330000',
      light: '#eea75b',
      dark: '#5a0000',
      contrastText: '#ffffff'
    },
    success: {
      main: '#29A855',
      light: '#2CB55C',
      dark: '#10602C',
      contrastText: '#ffffff'
    },
    error: {
      main: '#DF2901',
      light: '#991C00',
      dark: '#E9694D',
      contrastText: '#ffffff'
    },
    warning: {
      main: '#FBD300',
      light: '#DFFC30',
      dark: '#615100',
      contrastText: '#121212'
    },
    background: {
      default: '#ffffff',
      othersTopbar: '#fff',
      sectionOddBg: '#F4F8FC',
      sectionAltBg: '#e5e9f7',
      dark: '#f2ffff',
      paper: '#ffffff',
      stepperActiveFill: '#00857D',
      stepperNormalText: '#fff',
      stepperActiveText: '#fff',
      stepperCompletedText: '#fff',
      success: '#6ca342',
      error: '#DF2901',
      white: '#ffffff'
    },
    text: {
      primary: '#121212',
      secondary: '#5F5753',
      disabled: 'rgba(36, 36, 36, 0.38)',
      hint: 'rgba(36, 36, 36, 0.38)',
      navSecondary: '#121212',
      navActive: '#121212',
      textSecondary: '#121212',
      textActive: '#121212',
      error: '#C91A13',
      success: '#29A855',
      gray900: '#1C1D21CC',
      tooltip: '#1C1D21',
      cngBlack: '#1C1D21',
      widgetTitle: '#1c1d21',
      widgetSubTitle: '#7680a3',
      base: '#121212'
    },
    color: {
      primaryColor: '#00857D',
      primaryDark: '#00716a',
      primaryGray: '#7680a3',
      secondaryGreen: '#29A855',
      secondaryRed: '#ff808b',
      primaryAzure: '#3300001a',
      white: '#ffffff'
    },
    component: {
      navBar: {
        primary: {
          active: '#236EC326',
          contrastText: '#121212',
          hover: '#236EC326'
        },
        secondary: {
          active: '#236EC3',
          contrastText: '#121212',
          hover: '#E9F1F9'
        }
      },
      dropzone: {
        normalFill: '#fff',
        normalBorder: '#EEEEEE',
        hoverborder: 'rgba(94, 129, 244, 1)',
        hoverFill: 'rgba(94, 129, 244, 0.08)',
        activeFill: 'rgba(94, 129, 244, 0.08)'
      },
      chart: {
        gridLines: '#e8e8e8',
        zeroLine: '#a7a7a7',
        polarCircleBorder: '#e8e8e8',
        radarCircleBorder: '#e8e8e8',
        legend: '#1C1D21',
        label: '#1C1D21'
      },
      topBarMegaMenu: {
        backgroundFill: 'rgba(255, 255, 255, 1)',
        gradientStartFill: 'rgba(255, 255, 255, 0.5)',
        gradientEndFill: 'rgba(137, 150, 175, 18%)',
        degree: '150deg',
        scrollbarFill: '#ffffff',
        scrollbarThumbFill: '#7680a3',
        scrollbarTrackFill: '#f0f1f5',
        lineGradientStartFill: 'rgba(255, 255, 255, 0.1)',
        lineGradientMidFill: 'rgba(137, 150, 175, 0.5)',
        lineGradientEndFill: 'rgba(255, 255, 255, 0.1)'
      },
      paper: { borderColor: '#F5F5FA', fill: '#FFFFFF' },
      toggleButton: {
        normalFill: '#FFFFFF',
        hoverFill: '#ECECF2',
        activeFill: '#FFFFFF',
        activeBorder: '#ECECF2',
        normalText: '#7680a3',
        activeText: '#1C1D21'
      },
      stepper: {
        normalFill: '#EFC99E',
        activeFill: '#00857D',
        completedFill: '#00857D',
        normalText: '#1C1D21CC',
        activeText: '#1C1D21',
        completedText: '#1C1D21CC',
        iconFill: '#FFFFFF'
      },
      pagination: {
        btnNormalText: '#1C1D21',
        btnHoverFill: '#F5F5FA',
        btnActiveFill: '#00857D',
        btnActiveText: '#FFFFFF',
        btnNavNormalFill: '#F5F5FA',
        btnNavNormalText: '#7680a3',
        btnNavHoverFill: '#E8E8E8'
      },
      dropdown: {
        normalFill: 'rgba(94, 129, 244, 0.019)',
        normalBorder: '#EEEEEE',
        normalArrowFill: '#6ca342',
        placeholderText: 'rgba(0, 0, 0, 0.64)',
        valueText: '#1C1D21',
        hoverFill: 'rgba(94, 129, 244, 0.039)',
        activeFill: 'rgba(94, 129, 244, 0.019)',
        activeBorder: '#00857D',
        activeArrowFill: '#00857D'
      },
      hamburger: { stateClose: '#7680a3', stateOpen: '#1C1D21' },
      snackBar: {
        displayText: '#FFFFFF',
        iconFill: '#FFFFFF',
        success: '#29A855',
        error: '#DF2901',
        info: '#8996af',
        warning: '#f67402',
        actionIconFill: '#FFFFFF9A'
      },
      bannerAlert: {
        displayText: '#121212',
        actionTextLink: '#5F5753',
        actionIconFill: '#0a8080',
        bannerFill: '#ffc400'
      },
      checkbox: {
        hoverFill: '#E2E2E2',
        unCheckHoverFill: '#1C1D210B',
        unCheckHoverBorder: '#1C1D2129',
        checkHoverFill: '#3300001F',
        checkHoverBorder: '#3300004D'
      },
      switch: {
        trackNormalFill: '#f2f1ef',
        trackNormalDisabledFill: '#f2f1ef65',
        trackNormalDisabledBorder: '#f2f1ef4D',
        trackActiveFill: '#0a8080',
        trackActiveDisabledFill: '#0a808080',
        thumbFill: '#FFFFFF',
        thumbBorder: '#1C1D2133',
        thumbDisabledFill: '#FFFFFF',
        thumbDisabledBorder: '#1C1D2115'
      },
      dialog: {
        fill: '#FFFFFF',
        headerDivider: '#F6F6F6',
        closeIconFill: '#1C1D219A',
        titleText: '#1C1D21',
        bodyText: '#1C1D21CC'
      },
      cngCheckbox: {
        normalFill: '#F0F0F3',
        normalBorder: '#5f5753',
        normalDisabledFill: '#5f575367',
        normalDisabledBorder: '#5f57534D',
        hoverFill: '#EEEEEE',
        hoverBorder: 'transparent',
        hoverRippleFill: '#0a808010',
        normalHoverRipple: '#1C1D2105',
        activeHoverRipple: '#0a80801a',
        activeFill: '#00857D',
        activeDisabledFill: '#0a808080',
        forLabelText: '#5F5753',
        indeterminateIcon: '#0a8080'
      },
      slider: {
        railNormalFill: 'rgba(94, 129, 244, 0.235)',
        trackNormalFill: '#00857D',
        thumbNormalFill: '#7CE7AC',
        thumbBorder: '#FFFFFF',
        railDisabledFill: '#EEEEEE2E',
        trackDisabledFill: '#E7E9F280',
        thumbDisabledFill: '#D6D6D6',
        thumbDisabledBorder: '#E7E9F2',
        hoverRippleFill: '#3300001F',
        hoverRippleBorder: '#3300003E',
        mark: 'rgba(118, 128, 163, 0.501)',
        markActive: '#FFFFFF9F',
        valueFill: '#EEEEEE',
        valueText: '#252631'
      },
      linearProgress: { railFill: '#F6F6F6', progressBarFill: '#7CE7AC' },
      textFormControl: {
        normalFill: 'transparent',
        normalBorder: '#5f5753',
        normalArrowFill: '#236EC3',
        placeholderText: 'rgba(0, 0, 0, 0.64)',
        placeholderTextFilled: '#7680a3',
        placeholderTextFocused: '#000',
        placeholderTextFocusedHover: '#1c1d21cb',
        placeholderTextError: '#DF2901',
        placeholderTextDisabled: 'rgba(0, 0, 0, 0.25)',
        valueText: '#1C1D21',
        helperText: 'rgba(0, 0, 0, 0.9)',
        helperTextError: '#DF2901',
        hoverFill: '#E9F1F9',
        hoverBorder: '#5f5753',
        activeFill: '#E9F1F9',
        activeBorder: '#121212',
        activeArrowFill: '#00857D',
        dropdownFill: '#fafbfc',
        dropdownMenuHoverFill: '#33000019',
        dropdownMenuSelectedFill: '#1c1d210f',
        calendarControlFill: '#ffffff',
        calendarControlNavBtnNormalFill: '#F5F5FA',
        calendarControlNavBtnHoverFill: '#dedee4',
        calendarControlNavBtnIconFill: '#7680a3',
        calendarControlDayLabel: '#1C1D21',
        groupSelectNormalFill: '#efefef',
        groupSelectHoverFill: 'rgba(94, 129, 244, 0.08)',
        groupSelectActiveFill: 'rgba(94, 129, 244, 0.08)',
        disabledBorder: 'rgba(117, 117, 117, 0.2)',
        disabledFill: 'transparent',
        overallDisabledFieldOpacity: 1
      },
      chips: {
        normalFill: 'rgba(94, 129, 244, 0.1)',
        valueText: '#1C1D21CC',
        clickableHoverFill: '#1C1D210F',
        clickableFocusedFill: '#1C1D2133',
        clickableValueText: '#00857D',
        avatarFill: '#FFFFFF',
        avatarBorder: '#e2e1e1',
        avatarText: '#1C1D21CC',
        avatarIconFill: '#1C1D21CC',
        actionBtnNormalFill: 'transparent',
        actionBtnHoverFill: '#ffffff',
        actionBtnIconFill: '#1C1D219A',
        disabledFill: '#F6F6F6',
        disabledText: '#1c1d2154',
        outlineChipFill: 'transparent',
        outlineChipBorder: 'rgba(94, 129, 244, 0.6)',
        outlineChipDisabledFill: 'transparent',
        outlineChipDisabledBorder: '#1C1D2133',
        outlineClickableHoverFill: '#F5F5FA',
        outlineClickableFousedFill: '#F0F0F3'
      },
      cngMuiTable: {
        tableFill: 'transparent',
        tableBorder: '#E4EBF6A3',
        tableShadow: '#00000008',
        toolbarFill: 'transparent',
        toolbarTitle: '#1C1D21',
        toolbarSubTitle: '#7680a3',
        toolbarIconFill: '#7680a3',
        toolbarHighlightFill: '#ffffff',
        toolbarHighlightText: '#7680a3',
        tableHeaderFill: '#F5F5FA65',
        tableHeaderCellFill: '#F5F5FA65',
        tableHeaderProgressRail: '#ECECF2',
        tableHeaderProgressTrack: '#00857D',
        tableHeaderCellText: '#1C1D21',
        tableBodyRowCellText: '#1C1D21CC',
        tableBodyRowFill: '#FFFFFF',
        tableBodyRowBorder: '#E4EBF6A2',
        tableBodyRowCellBorder: '#E4EBF6A2',
        tableBodyHighlightedRowFill: 'rgba(118, 128, 163, 0.058)',
        tableBodySelectedRowFill: 'rgba(94, 129, 244, 0.098)',
        tableBodySelectedRowBorder: '#E4EBF6A2',
        tableBodySelectedRowCellBorder: '#E4EBF6A2',
        tablePageBtnHoverFill: '#ececec',
        tablePageBtnDisabledFill: '#f5f5fa80'
      },
      functionButtons: {
        normalFill: '#F5F5FA',
        normalIconFill: '#7680a3',
        hoverFill: '#33000019',
        focusFill: '#33000019',
        activeFill: '#33000019',
        activeIconFill: '#7680a3'
      },
      popoverMenu: {
        paperFill: '#FFFFFF',
        listItemNormalFill: '#FFFFFF',
        listItemHoverFill: 'rgba(118, 128, 163, 0.062)',
        listItemText: '#1C1D21',
        listItemIconFill: '#1C1D21',
        listItemActiveFill: 'rgba(118, 128, 163, 0.062)'
      },
      innerPage: {
        pageFill: '#FFFFFF',
        primaryTitle: '#1C1D21',
        secondaryTitle: '#1C1D21',
        paragraph: '#1C1D21CC',
        linkTextBlue: '#00857D',
        linkTextWhite: '#FFFFFF',
        iconFill: '#FFFFFF'
      },
      numericStepper: {
        normalLabel: '#1C1D2133',
        activeLabel: '#00857D',
        normalFill: 'transparent',
        normalBorder: '#EEEEEE',
        hoverBorder: '#EEEEEE',
        valueText: '#1C1D21'
      },
      cngButton: {
        contrastText: '#ffffff',
        outline: {
          normalFill: '#FFFFFF',
          border: '#00857D',
          positiveFaceColor: '#00857D',
          negativeFaceColor: '#DF2901',
          disabledFaceColor: '#1C1D2133',
          hoverFill: '#E7F2F2',
          activeFill: '#E7F2F2',
          disabledFill: 'transparent'
        },
        function: {
          primaryNormalFill: '#236EC3',
          primaryHoverFill: '#1C589C',
          primaryActiveFill: '#1C589C',
          primaryDisabledFill: '#33000033',
          primaryFaceColor: '#FAFBFF',
          secondaryNormalFill: '#330000',
          secondaryHoverFill: '#5a0000',
          secondaryActiveFill: '#5a0000',
          secondaryDisabledFill: '#00857D33',
          secondaryFaceColor: '#7680a3',
          outlineNormalFill: '#ffffff',
          outlineBorder: '#D3E2F3',
          outlineFaceColor: '#236EC3',
          disabledFaceColor: '#1C1D2133',
          outlineHoverFill: '#E9F1F9',
          outlineActiveFill: '#E9F1F9',
          outlineDisabledFill: 'transparent'
        },
        text: {
          contrastText: '#7680a3',
          hoverFill: 'rgba(118, 128, 163, 0.058)',
          activeFill: 'rgba(94, 129, 244, 0.3)'
        }
      },
      appBar: { contrastText: '#263238' },
      breadcrumbGoBackBtn: { normalFill: 'transparent', hoverFill: '#1C589C' },
      signatureCanvas: {
        penColor: 'black',
        normalFill: '#fcfdff',
        errorFill: '#fefcfd',
        normalBorder: '#00857D',
        errorBorder: '#DF2901',
        errorText: '#DF2901'
      }
    }
  },
  props: {
    MuiButton: { disableRipple: true },
    MuiCheckbox: {
      color: 'secondary',
      disableFocusRipple: true,
      disableRipple: true
    }
  },
  shadows: [
    'none',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 1px 2px -2px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 2px 2px -2px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 3px 4px -2px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 3px 4px -2px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 4px 6px -2px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 4px 6px -2px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 4px 8px -2px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 5px 8px -2px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 6px 12px -4px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 7px 12px -4px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 6px 16px -4px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 7px 16px -4px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 8px 18px -8px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 9px 18px -8px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 10px 20px -8px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 11px 20px -8px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 12px 22px -8px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 13px 22px -8px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 14px 24px -8px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 16px 28px -8px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 18px 30px -8px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 20px 32px -8px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 22px 34px -8px rgba(0,0,0,0.1)',
    '0 0 1px 0 rgba(0,0,0,0.08), 0 24px 36px -8px rgba(0,0,0,0.1)'
  ]
}

export default modernBlueTheme
